import { RoutePathContext } from "context/ViewContext/RoutePathContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useRoutePath = () => {
  return useProviderInitializedContext(RoutePathContext);
};
